import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import {
	ListPreview,
	ListPreviewResult,
	ListPreviewStatus,
} from "../../pages/List/pages/ListEditDetails/schema/listPreview";

import { listPreviewApi } from "./listPreview.api";

export interface ListPreviewState {
	activePreview: ListPreview | null;
	results: ListPreviewResult[];
	isPolling: boolean;
}

const initialState: ListPreviewState = {
	activePreview: null,
	results: [],
	isPolling: false,
};

export const listPreviewSlice = createSlice({
	name: "listPreview",
	initialState,
	reducers: {
		setPolling: (state, action: PayloadAction<boolean>) => {
			state.isPolling = action.payload;
		},
		clearPreview: (state) => {
			state.activePreview = null;
			state.results = [];
			state.isPolling = false;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			listPreviewApi.endpoints.startPreview.matchFulfilled,
			(state, { payload }) => {
				state.activePreview = payload;
				state.results = [];
				state.isPolling = true;
			}
		);
		builder.addMatcher(
			listPreviewApi.endpoints.getPreviewStatus.matchFulfilled,
			(state, { payload }) => {
				state.activePreview = payload;

				if (
					payload.status === ListPreviewStatus.PENDING ||
					payload.status === ListPreviewStatus.RUNNING
				) {
					state.isPolling = true;
				} else {
					state.isPolling = false;
				}
			}
		);
		builder.addMatcher(
			listPreviewApi.endpoints.getPreviewResults.matchFulfilled,
			(state, { payload }) => {
				if (payload?.data) {
					state.results = payload.data;
				}
			}
		);
		builder.addMatcher(
			listPreviewApi.endpoints.stopPreview.matchFulfilled,
			(state, { payload }) => {
				state.activePreview = payload;
				state.isPolling = false;
			}
		);
		builder.addMatcher(
			listPreviewApi.endpoints.rerunPreview.matchFulfilled,
			(state, { payload }) => {
				state.activePreview = payload;
				state.results = [];
				state.isPolling = true;
			}
		);
		builder.addMatcher(
			listPreviewApi.endpoints.extendPreview.matchFulfilled,
			(state, { payload }) => {
				state.activePreview = payload;
				state.isPolling = true;
			}
		);
	},
});

export const { setPolling, clearPreview } = listPreviewSlice.actions;
export const listPreviewReducer = listPreviewSlice.reducer;
export const listPreviewSelector = (state: RootState) => state[listPreviewSlice.name];
